import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FAQPage from './pages/FAQPage';
import CRMPage from './pages/CRMPage';
import EventosPage from './pages/EventosPage';
import ERPPage from './pages/ERPPage';
import IAPage from './pages/IAPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ProductsPage from './pages/ProductsPage';

function HomePage() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <>
      <Header />
      <Hero />
      <Features />
      <About />
      {/* <Testimonials /> */}
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/produtos" element={<ProductsPage />} />
          <Route path="/sobre" element={<AboutPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/crm" element={<CRMPage />} />
          <Route path="/eventos" element={<EventosPage />} />
          <Route path="/erp" element={<ERPPage />} />
          <Route path="/ia" element={<IAPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
